/**
 * Copyright (c) 2019-present.
 * All rights reserved.
 *
 * @author link-all
 *
 * @file SuspenseHolder
 */

import React from 'react';

import { Loading } from '@libs/a-component';
import { Progress } from '@libs/utils';

export interface IPropsAsyncLoader {
    compoLazy?(): Promise<{ default: any }>;

    compoProps?: any;
    fallback?: NonNullable<React.ReactNode> | null;
    forbidProgress?: boolean; // 禁用加载进度条
}

const STYLE_Holder: React.CSSProperties = {
    height: '80%',
    backgroundColor: 'transparent', // 'rgba(255,255,255,0.35)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

/**
 * 缓存 importPromise 函数，已加载的外部 js 不再重复加载
 */
const compClasses: Array<{ func: any, comp: any }> = [];

export class AsyncLoader extends React.Component<IPropsAsyncLoader, any> {
    private readonly lazyCompo?: React.LazyExoticComponent<any>;
    private compClass: any = null;

    constructor(props) {
        super(props);

        if (this.props.compoLazy) {
            const item = compClasses.find(cc => cc.func === this.props.compoLazy);
            if (item) {
                this.compClass = item.comp;
                return;
            }

            !this.props.forbidProgress && Progress.start();
            this.lazyCompo = React.lazy(
                // @ts-ignore
                () => this.props.compoLazy().then(
                    it => {
                        !this.props.forbidProgress && Progress.done();

                        if (!compClasses.find(cc => cc.func === this.props.compoLazy)) {
                            compClasses.push({
                                func: this.props.compoLazy,
                                comp: it.default,
                            });
                            // console.log(compClasses.length);
                        }
                        return it;
                    },
                ),
            );
        }
    }

    public UNSAFE_componentWillReceiveProps(nextProps: Readonly<IPropsAsyncLoader>, nextContext: any): void {
        if (nextProps.compoLazy !== this.props.compoLazy) {
            console.error('compoLazy must be a unique constant varible');
        }
    }

    public render(): React.ReactNode {
        if (this.compClass) {
            return React.createElement(this.compClass, this.props.compoProps);
        }
        if (!this.lazyCompo) {
            return null;
        }
        const fallback = this.props.fallback || <div style={ STYLE_Holder }><Loading /></div>;
        return (
            <React.Suspense fallback={ fallback }>
                {
                    React.createElement(this.lazyCompo, this.props.compoProps)
                }
            </React.Suspense>
        );
    }
}

export default AsyncLoader;
